import React from "react";
import FormRow from "../../components/formrow";
import { type GetSetValueProp } from "../models";
import CulturesInterfaceDropdown from "components/dropdowns/reactselect/CulturesInterfaceDropdown";

const LanguageDropdown = (props: GetSetValueProp<string>) => {
  return <FormRow label={RESX.Language.resxLanguage}>
    <CulturesInterfaceDropdown
      value={serverReference.interfaceCultures.find(c => c.locale === props.value)}
      onChange={c => { props.setValue(c.locale); }}
    />
  </FormRow>;
};

export default LanguageDropdown;